import React from 'react';
import PropTypes from 'prop-types';

import Tipsy from 'zoomforth_component_lib/tipsy.jsx';
import { PageIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

const tipsyMsg = `This number reflects the number of published sites using this
  theme. Unpublished sites may be using this theme but they will not be reflected
  in this count until they are published.`;

const PagesInUse = ({ label })=> (
  <Tipsy content={tipsyMsg} placement="topRight">
    <span className="pages-in-use-container">
      <PageIcon /> {label}
    </span>
  </Tipsy>
);

PagesInUse.propTypes = {
  label: PropTypes.any.isRequired
};

export default PagesInUse;
